import { bindActionCreators } from "@reduxjs/toolkit"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { actionCreators } from "../../../state"
import { P2P } from "../../../P2PContext";
import { DexxButton } from "../../light/LightButton";
import { TitleColor1 } from "../../typography/Typogtaphy";
import P2PBuyPopup from "../../popup/P2PBuyPopup";
import P2PCreateOfferPopup from "../../popup/P2PCreateOfferPopup";
import { euroFormat } from "../../../utils";
import Cookies from 'universal-cookie';
import Popup, { DexxPopup } from '../../Popup'
import GenericTab from "../utils/GenericTab";
import CentralTabContent from "../utils/CentralTabContent";
import TableShadow from "../../light/TableShadow";


export default function P2PTokenTab(props: {
    p2ps: P2P[], tokenInfo: any
    refreshList: Function, isAmericanAndsportex?: boolean
}): JSX.Element {

    const cookies = new Cookies()
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    const [showCreateOfferPopup, setShowCreateOfferPopup] = useState<boolean>(false)
    const [showBuyPopup, setShowBuyPopup] = useState<boolean>(false)
    const [p2p, setP2P] = useState<P2P>()
    const [responseDelete, setResponseDelete] = useState<any[]>([0, undefined])

    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    const [confirmPopUp, setConfirmPopUp] = useState<boolean>(false)

    const showP2POffer = props.tokenInfo.p2p_flag && !props.isAmericanAndsportex

    function handleClosePopUp() {
        setTitlePopUp("")
        setMsgPopUp("")
        setConfirmPopUp(false)
        setShowPopUp(false)
    }

    function handleAction() {
        setTitlePopUp("Confirm your action")
        setMsgPopUp("Are you sure you want to delete your P2P Offer?")
        setConfirmPopUp(true)
        setShowPopUp(true)
    }

    function handleConfirmation() {
        handleClosePopUp()
        if (p2p && p2p.uuid) {
            actions.deleteP2POffer(p2p.uuid, setResponseDelete)
        }
        else {
            setTitlePopUp("Sorry!")
            setMsgPopUp("The offer you have selected does not exist.")
            setShowPopUp(true)
        }
    }

    useEffect(() => {
        if (responseDelete && responseDelete[0] !== 0) {
            switch (responseDelete[0]) {
                //case 200:
                case 204:
                    setTitlePopUp("Success")
                    setMsgPopUp("Your P2P Offer has been deleted.")
                    props.refreshList(true)
                    break
                default:
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error deleting your P2P Offer.  Please, try again.")
                    setShowPopUp(true)
            }
        }
    }, responseDelete)

    let p2ps = props.p2ps ? props.p2ps : []
    let r = p2ps.filter((l) => l.type_name === "ask").map((l, idx) => {
        return [l.token_total_amount, l.token_left_amount,
        "€" + euroFormat(l.per_token_price),
        <div className="flex justify-start md:justify-end" key={idx}>
            {
                cookies.get("username") !== l.acc_uuid && props.tokenInfo.p2p_flag ?
                    <DexxButton label={"buy"} className="rounded-lg px-10 font-normal"
                        color1="succ2" color2="succ2" color3="succ2_lightest"
                        onClick={() => { setShowBuyPopup(true); setP2P(l) }}
                    /> :
                    cookies.get("username") !== l.acc_uuid && !props.tokenInfo.p2p_flag ?

                        <DexxButton label={"buy"} noCursor noHoverOnSelected
                            className="px-10 rounded-lg " color2="gray9"
                            fontClasses=" text-base " />
                        :
                        (
                            <DexxButton label={"delete"}
                                color1="warning" color2="warning" color3="warning_lightest"
                                className="px-10 rounded-lg font-normal"
                                onClick={() => { handleAction(); setP2P(l) }}
                            />
                        )
            }
        </div>]
    })
    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true} close={handleClosePopUp}
            btnConfirm={confirmPopUp} handleConfirm={handleConfirmation} />
        {props.isAmericanAndsportex ? (
            <Popup show={showBuyPopup} title={"Sorry!"} msg={"US citizens are not allowed to buy this token." +
                " Take a look at Investment Restrictions for more details."}
                btnOk={true} close={() => { setShowBuyPopup(false) }} />
        ) : (
            <DexxPopup show={showBuyPopup} title={"Buy from P2P"}
                msg={<P2PBuyPopup tokenInfo={props.tokenInfo} p2p={p2p}
                    isShown={showBuyPopup} closeFunction={() => { setShowBuyPopup(false) }}
                    refreshList={props.refreshList} />}
                btnOk={false}
                close={() => { setShowBuyPopup(false) }} />
        )
        }

        <DexxPopup show={showCreateOfferPopup} title={"Create Offer"}
            type="alternate"
            msg={<P2PCreateOfferPopup tokenInfo={props.tokenInfo}
                isShown={showCreateOfferPopup}
                closeFunction={() => { setShowCreateOfferPopup(false) }}
                refreshList={props.refreshList} />}
            btnOk={false}
            close={() => { setShowCreateOfferPopup(false) }} />

        <GenericTab>
            <div>
                <TitleColor1 className="text-2xl grid w-full">
                    Offers:</TitleColor1>
                <div className="w-full flex my-4">
                    <DexxButton label={"Create a new one"} className={
                        " rounded-lg px-6 text-primary font-normal"}
                        noCursor={!showP2POffer} noHoverOnSelected={!showP2POffer}
                        color1="succ2" color2={showP2POffer ? "succ2" : "succ2_lighter"} 
                        color3="succ2_lightest"
                        onClick={() => { if (showP2POffer) setShowCreateOfferPopup(true) }} />
                </div>
                {p2ps.length > 0 ?
                    <TableShadow headers={["original qty", "remaining qty", "Price", ""]} rows={r} />
                    :
                    <CentralTabContent className="mt-20 text-white mb-10">
                        There are no offers yet.
                    </CentralTabContent>}
            </div>
        </GenericTab>
    </>
}